export default {
  background: "#FFFFFF",
  surface: "#FFFFFF",
  primary: "#569934",
  secondary: "#666666",
  error: "#B00020",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FB8C00",
  deno: "#4fb4d2",
  denodarken1: "#325a76",
  denolighten1: "#438aac",
  denolighten2: "#55aacc",
  denolighten3: "#72c3d8",
  denolighten4: "#bae5ee",
  denolighten5: "#eef7fc",
  fournisseur: "#cd8d03",
  fournisseurdarken1: "#c76700",
  fournisseurlighten1: "#d0a412",
  fourniseurlighten2: "#d3cb23",
  fournisseurlighten3: "#ded866",
  fournisseurlighten4: "#f1eebc",
  fournisseurlighten5: "#f9f6db",
  produit: "#1a7d34",
  produitdarken1: "#025e21",
  produitlighten1: "#258e3e",
  produitlighten2: "#38af53",
  produitlighten3: "#77c786",
  produitlighten4: "#c5e6ca",
  produitlighten5: "#d5eacf",
  multicritere: "#fb8B67",
  multicriterelighten1: "#fbe8e4",
};
